import type { RouteRecordRaw } from 'vue-router';
import { isModuleEnabled, getModuleOrder } from '@/app/shared/sheets';
import moduleIcons from '@/app/shared/module-icons';
const moduleRouteLoaders = import.meta.glob('@/app/modules/*/routes.ts', {
  eager: true,
});
const moduleRoutes = Object.values(moduleRouteLoaders)
  .flatMap((module) => {
    const exported = module as {
      default?: RouteRecordRaw[];
      routes?: RouteRecordRaw[];
    };
    if (exported.default) {
      return exported.default;
    }
    return exported.routes ?? [];
  })
  .filter((route) => {
    const path = typeof route.path === 'string' ? route.path : '';
    if (path === 'replenishment') {
      return isModuleEnabled('replenishment');
    }
    if (path === 'new-replenishment') {
      return isModuleEnabled('new-replenishment');
    }
    if (path === 'allocations') {
      return isModuleEnabled('allocations');
    }
    if (path === 'allocations-2') {
      return isModuleEnabled('allocations-2');
    }
    if (path === 'inventory') {
      return isModuleEnabled('inventory');
    }
    if (path === 'inventory-2') {
      return isModuleEnabled('inventory-2');
    }
    if (path === 'analytics') {
      return isModuleEnabled('analytics');
    }
    if (path === 'purchasing') {
      return isModuleEnabled('purchasing');
    }
    if (path === 'store-transfer') {
      return isModuleEnabled('store-transfer');
    }
    if (path === 'special-events') {
      return isModuleEnabled('special-events');
    }
    if (path === 'planning-assistant') {
      return isModuleEnabled('planning-assistant');
    }
    if (path === 'beta-reports') {
      return isModuleEnabled('beta-reports');
    }
    if (path === 'liquidation') {
      return isModuleEnabled('liquidation');
    }
    if (path === 'otb-execution') {
      return isModuleEnabled('otb-execution');
    }
    if (path === 'rules-engine') {
      return isModuleEnabled('rules-engine');
    }
    if (path === 'cfo-panel') {
      return isModuleEnabled('cfo-panel');
    }
    if (path === 'ceo-panel') {
      return isModuleEnabled('ceo-panel');
    }
    if (path === 'cco-panel') {
      return isModuleEnabled('cco-panel');
    }
    return true;
  });
const placeholderRoutes: RouteRecordRaw[] = [];
if (isModuleEnabled('analytics')) {
  placeholderRoutes.push({
    path: 'analytics',
    component: () => import('@/app/views/module-empty.vue'),
    props: {
      titleKey: 'globalNavigation.analytics',
      icon: moduleIcons.Analytics,
    },
  });
}
if (isModuleEnabled('planning-assistant')) {
  placeholderRoutes.push({
    path: 'planning-assistant',
    component: () => import('@/app/views/module-empty.vue'),
    props: {
      titleKey: 'globalNavigation.planningAssistant',
      icon: moduleIcons.PlanningAssistant,
    },
  });
}
const moduleOrder = getModuleOrder();
const firstEnabledModule = moduleOrder
  ? moduleOrder.find((key) => moduleRoutes.some((route) => route.path === key))
  : null;
const defaultRoute = firstEnabledModule
  ? moduleRoutes.find((route) => route.path === firstEnabledModule)
  : moduleRoutes[0];
const noModulesEnabled = moduleRoutes.length === 0;
const defaultRedirect = (() => {
  if (!defaultRoute) {
    return noModulesEnabled ? '/demo-unavailable' : '/';
  }
  if (typeof defaultRoute.redirect === 'string') {
    return defaultRoute.redirect;
  }
  if (typeof defaultRoute.path === 'string' && defaultRoute.path) {
    return `/${defaultRoute.path}`;
  }
  return '/';
})();
export const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/app/layouts/default-layout.vue'),
    children: [
      {
        path: '',
        redirect: defaultRedirect,
      },
      {
        path: 'demo-unavailable',
        component: () => import('@/app/views/demo-unavailable.vue'),
        beforeEnter: () => {
          return noModulesEnabled ? true : defaultRedirect;
        },
        meta: {
          layoutFeatures: {
            sidebar: false,
          },
        },
      },
      ...placeholderRoutes,
      ...moduleRoutes,
    ],
  },
  {
    path: '/:catchAll(.*)',
    component: () => import('@/app/views/not-found.vue'),
  },
];
